import {ModuleWithProviders, NgModule} from '@angular/core';
import {MatIconModule} from '@angular/material/icon';
import {CommonModule} from '@angular/common';
import { ModalComponent } from './modal/modal.component';
import {MatDialogModule} from '@angular/material/dialog';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {NgxDropzoneModule} from 'ngx-dropzone';
import {MaterialModule} from './material/material.module';
import { ImageComponent } from './image/image.component';
import { GalleryComponent } from './gallery/gallery.component';
import {BrowserModule} from '@angular/platform-browser';
import {HttpClientModule} from '@angular/common/http';
import { EditorComponent } from './editor/editor.component';
import {AngularEditorModule} from '@kolkov/angular-editor';
import {FormlyModule} from '@ngx-formly/core';



@NgModule({
  declarations: [ModalComponent, ImageComponent, GalleryComponent, EditorComponent],
    imports: [
        MatIconModule,
        CommonModule,
        BrowserModule,
        MatDialogModule,
        FormsModule,
        NgxDropzoneModule,
        MaterialModule,
        HttpClientModule,
        AngularEditorModule,
        ReactiveFormsModule,
        FormlyModule
    ],
  exports: [ModalComponent, ImageComponent, GalleryComponent, EditorComponent ]

})
export class VahaglibdevModule {
    static forRoot(configuration): ModuleWithProviders<any> {
        return {
            ngModule: VahaglibdevModule,
            providers: [VahaglibdevModule, { provide: 'config', useValue: configuration}]
        };
    }


}
